import React from 'react';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import './ckeditor.css';

type CKEditorComponentProps = {
    value: string;
    onChange: (value: string) => void;
    isDisabled: boolean;
}

const CKEditorComponent: React.FC<CKEditorComponentProps> = ({ value, onChange, isDisabled }) => {
    return (
        <CKEditor
            editor={ClassicEditor}
            data={value}
            onChange={(_event: any, editor: any) => {
                const data = editor.getData();
                onChange(data);
            }}
            disabled={isDisabled}
        />
    );
};

export default CKEditorComponent;
